import { render } from "./the-header.vue?vue&type=template&id=2e985422&scoped=true&ts=true"
import script from "./the-header.vue?vue&type=script&lang=ts"
export * from "./the-header.vue?vue&type=script&lang=ts"

import "./the-header.vue?vue&type=style&index=0&id=2e985422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e985422"]])

export default __exports__